import { render, staticRenderFns } from "./RegionLandingPage.vue?vue&type=template&id=a56dc22c&scoped=true&"
import script from "./RegionLandingPage.vue?vue&type=script&lang=js&"
export * from "./RegionLandingPage.vue?vue&type=script&lang=js&"
import style0 from "./RegionLandingPage.vue?vue&type=style&index=0&id=a56dc22c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56dc22c",
  null
  
)

export default component.exports